import { GoogleLogin } from "@react-oauth/google";
import React, { useState } from "react";
import Loader from "../reusble_components/loader";
import jwt_decode from "jwt-decode";
import { apiLink } from "../../helpers/constantVariables";
import axios from "axios";
import { apiDelete } from "../../api/api_methods";

export default function DeleteMyAccount() {
  const [loading, setloading] = useState(false);
  const [isAccountDeleted, setIsAccountDeleted] = useState(false);

  const deleteAccount = async (gid) => {
    setloading(true);
    try {
      const response = await apiDelete(`/user/delete/${gid}`);
      if (response.status === 200) {
        setIsAccountDeleted(true);
        localStorage.clear();
      } else {
        alert(`Failed to delete account. Status: ${response.body.message}`);
      }
      setloading(false);
    } catch (error) {
      console.error("Error:", error); // Log the error for debugging
      alert(`Failed to delete account. Status: ${error.message}`);
      setloading(false);
    }
  };

  const onSuccessLogin = (response) => {
    const userObject = jwt_decode(response.credential);
    console.log(userObject);
    localStorage.setItem("user_google", JSON.stringify(userObject));
    deleteAccount(userObject?.sub);
    // loginUser(
    //   userObject?.email,
    //   userObject?.sub,
    //   userObject?.name,
    //   userObject?.picture
    // );
  };

  return (
    <div className="gil-reg flex flex-col items-center justify-center h-[100vh] w-full">
      <Loader loader={loading} />
      <p className="text-3xl">Delete account</p>
      <p className="mb-4">
        Click on Below button and select your mail to delete your account
      </p>
      {!isAccountDeleted ? (
        <GoogleLogin
          id="google-login"
          onSuccess={(credentialResponse) => {
            console.log(credentialResponse);
            onSuccessLogin(credentialResponse);
          }}
          onError={() => {
            console.log("Login Failed");
            alert("Login Failed");
          }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl text-green-600">
            Account deleted successfully
          </p>

          <a href="/" className="gil-reg text-lg mt-4 underline">
            Go to home
          </a>
        </div>
      )}
    </div>
  );
}
